import React, { useState, useEffect } from "react";
import "../Assests/Scss/AddStudent.scss";
import axios from "axios";
import {
  Grade,
} from "../../Student/Reusablecomponents/RegularFunctions";
import * as Yup from "yup";
import Dropdown from "../../Student/Reusablecomponents/DropDown";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import notify from "../../ReusableComponents/ToastifyAlerts";

const AddStudent = (props) => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const convertDateFormat = (dateString) => {
    const parts = dateString.split("/");
    const year = parts[2];
    const month = parts[1];
    const day = parts[0].padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const capitalizeWords = (str) => {
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  };
  const [ElectiveSubjects, SetElectiveSubjects] = useState([]);
  const [MediumofInstruction, SetMediumofInstruction] = useState([]);
  const [OptionalSubjects, SetOptionalSubjects] = useState([]);
  const [OptionalSubjectId, SetOptionalSubjectsId] = useState(props.EditDetails?.optionalSubjectId || items.languageSubjectId?.split(",").length > 1 ? props.EditDetails?.optionalSubjectId || "" :  items?.languageSubjectId );

  const [GetGrade, SetGetGrade] = useState(
    props.EditDetails?.grade || props.Grade
  );
  const [GetSection, SetGetSection] = useState(
    props.EditDetails?.section || ""
  );
  const [ElectiveId, SetElectiveId] = useState();
  const [PstStatus, SetPstStatus] = useState([]);
  const [MediumofInstructionId, SetMediumofInstructionId] = useState(items?.mediumId);
  const [PSTStatusId, SetPSTStatusId] = useState(props.EditDetails?.pstStatus);
  const [StudentDetails, SetStudentDetails] = useState({
    FName: props.EditDetails?.firstName || "",
    LName: props.EditDetails?.lastName || "",
    DOB: props.EditDetails
      ? convertDateFormat(props.EditDetails?.dateOfBirth)
      : "",
    Gender: props.EditDetails?.gender || "",
    PContactNo: props.EditDetails?.parentsMobileNo || "",
    PSTStatusId: props.EditDetails?.pstStatus || "",
  });
  const [ErrorMessage, setErrors] = useState({});

  const validationSchema = Yup.object().shape({
    FName: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "First Name should only contain alphabets and spaces"
      )
      .max(50, "First Name cannot exceed 50 characters")
      .required("First Name is required")
      .test(
        "no-start-space",
        "First Name cannot start with a space",
        (value) => !/^\s/.test(value)
      ),

    DOB: Yup.date()
      .nullable()
      .required("Date of Birth is required")
      .typeError("Date is required"),
    Gender: Yup.string().required("Gender is required"),
    GetSection: Yup.string().required("Section is required"),
    GetGrade: Yup.string().required("Grade is required"),
    ElectiveId: Yup.string().when("GetGrade", {
      is: () => GetGrade == "12" || GetGrade == "11",
      then: (schema) => Yup.string().required("Elective Subject is required"),
      otherwise: (schema) => Yup.string().notRequired(),
    }),
    MediumofInstructionId: Yup.string().required(
      "Medium of Instruction is required"
    ),
    PContactNo: Yup.string()
      .notRequired()
      .test(
        "is-valid-phone",
        "Please enter a valid Contact Number",
        (value) => {
          if (!value) return true;
          return /^\d{10}$/.test(value);
        }
      ),
   
    OptionalSubjectId: Yup.string().when("GetGrade", {
      is: (grade) => Number(grade) <= 10,
      then: () =>
        Yup.string().required("Language is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    PSTStatusId:items?.societyName === "NATCO"
    ? Yup.string().required("PST Status is required")
    : Yup.string().notRequired(),
  });

  const SubmitForm = () => {
    const fullStudentDetails = {
      ...StudentDetails,
      GetSection,
      GetGrade,
      ElectiveId,
      MediumofInstructionId,
      OptionalSubjectId,
      PSTStatusId,
    };
    validationSchema
      .validate(fullStudentDetails, { abortEarly: false })
      .then(() => {
        if (props.EditDetails) {
          PostAddStudent(fullStudentDetails);
        } else {
          CheckStudent(fullStudentDetails);
        }
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };

  const PostAddStudent = async (fullStudentDetails) => {
    const AddstudentDetails = {
      firstName: capitalizeWords(fullStudentDetails.FName),
      lastName: capitalizeWords(fullStudentDetails.LName),
      gender: fullStudentDetails.Gender,
      dateOfBirth: fullStudentDetails.DOB,
      electiveSubjectId: ElectiveId,
      class: fullStudentDetails.GetGrade,
      schoolId: items.schoolId,
      createdBy: items.userId,
      modifiedBy: props.EditDetails ? items.userId : 0,
      userId: props.EditDetails?.userId || 0,
      teacherClassIds: "string",
      teacherSubjectIds: "string",
      email: "string",
      contactPhone: "string",
      Section: fullStudentDetails.GetSection,
      mediumofInstruction: MediumofInstructionId,
      parentsMobileNo: fullStudentDetails.PContactNo,
      optionalSubjectId: OptionalSubjectId || 0,
      pstStatus: PSTStatusId || 0,
    };
    if (props.EditDetails) {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/School/UpdateStudentDetails",
          AddstudentDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          props.Cancle(false);
          props.StudentCount();
          notify("Student updated successfully", "success");
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/School/InsertStudentDetails",
          AddstudentDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then((res) => {
          props.Cancle(false);
          props.StudentCount();
          notify("Student added successfully", "success");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const FIllDetails = (e) => {
    SetStudentDetails({
      ...StudentDetails,
      [e.target.name]: capitalizeWords(e.target.value),
    });
  };
  const HoldSection = (e) => {
    SetGetSection(e.target.value);
  };

  const GetElectiveSubject = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetSubjectCategoryForGrade?LovCategoryId=67`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Subjects = res.data.map((sub) => ({
          display: sub.lovDescription,
          value: sub.lovId,
        }));
        SetElectiveSubjects(Subjects);
        if (props.EditDetails) {
          SetElectiveId(
            res.data.filter(
              (sub) =>
                sub.lovDescription === props.EditDetails.electiveSubjectName
            )[0].lovId
          );
        } else {
          SetElectiveId("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (GetGrade >= 11) {
      GetElectiveSubject();
    }
  }, [GetGrade]);

  const PSTStatus = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/GetSubjectCategoryForGrade?LovCategoryId=129`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const status = res.data.map((sub) => ({
          display: sub.lovDescription,
          value: sub.lovId,
        }));
        SetPstStatus(status);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
  PSTStatus();
}, []);

  const CheckStudent = async (FSD) => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/School/IsStudentExists?FirstName=${FSD.FName}&LastName=${FSD.LName}&DateOfBirth=${FSD.DOB}&Grade=${FSD.GetGrade}&Gender=${FSD.Gender}&schoolId=${items.schoolId}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (parseInt(res.data) === 0) {
          PostAddStudent(FSD);
        } else {
          notify(`Student already existed and the id is ${res.data}`, "error");
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <div className="Card AddStudent-maindiv">
        <div className="dflex alignitems JSBetween">
          <div className="AddStudent-Title Helvetica">
            {props.EditDetails ? "Edit" : "Add"} student
          </div>
          <IoMdCloseCircleOutline onClick={() => props.Cancle(false)} />
        </div>
        <div className="Student-Details-Form mt-3">
          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              First Name <span>*</span>
            </label>
            <input
              type="text"
              name="FName"
              placeholder="Enter First Name"
              value={StudentDetails.FName} onChange={(
                e
              ) => FIllDetails(e)}
            />
            {ErrorMessage.FName && (
              <div className="error-message">{ErrorMessage.FName}</div>
            )}
          </div>

          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>Last Name</label>
            <input
              type="text"
              name="LName"
              placeholder="Enter Last Name"
              value={StudentDetails.LName} onChange={(
                e
              ) => FIllDetails(e)}
            />
          </div>

          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              Grade <span>*</span>
            </label>
            <Grade
              PostGrade={SetGetGrade}
              id="ddlGrade"
              selected={"Grade " + GetGrade}
            />
            {ErrorMessage.GetGrade && (
              <div className="error-message">{ErrorMessage.GetGrade}</div>
            )}
          </div>

          {GetGrade >= 11 && (
            <div className="dflex flexd-column" style={{ gap: "5px" }}>
              <label>
                Elective Subject <span>*</span>
              </label>
              <DropdownValues
                options={ElectiveSubjects}
                onChange={(e) => SetElectiveId(e.target.value)}
                selectoption={ElectiveId}
                Displayname="Select Elective Subject"
              />
              {ErrorMessage.ElectiveId && (
                <div className="error-message">{ErrorMessage.ElectiveId}</div>
              )}
            </div>
          )}

          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              Date of Birth <span>*</span>
            </label>
            <input
              type="date"
              name="DOB"
              defaultValue={
                props.EditDetails
                  ? convertDateFormat(props.EditDetails?.dateOfBirth)
                  : StudentDetails.DOB
              }
              max={`${new Date().getFullYear() - 5}-12-31`}
              onChange={(e) => FIllDetails(e)}
            />
            {ErrorMessage.DOB && (
              <div className="error-message">{ErrorMessage.DOB}</div>
            )}
          </div>

          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              Section <span>*</span>
            </label>
            <Dropdown
              options={["A", "B", "C", "D", "X"]}
              id="ddlSection"
              selectoption={GetSection}
              onChange={(e) => HoldSection(e)}
              Displayname="Select Section"
            />
            {ErrorMessage.GetSection && (
              <div className="error-message">{ErrorMessage.GetSection}</div>
            )}
          </div>

          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              Gender <span>*</span>
            </label>
            <div
              className="dflex alignitems"
              style={{ gap: "5px", border: "none" }}
            >
              <input
                type="radio"
                name="Gender"
                value="M"
                defaultChecked={StudentDetails.Gender === "M"}
                onChange={(e) => FIllDetails(e)}
              />{" "}
              Boy
              <input
                type="radio"
                name="Gender"
                value="F"
                defaultChecked={StudentDetails.Gender === "F"}
                onChange={(e) => FIllDetails(e)}
              />{" "}
              Girl
              <input
                type="radio"
                name="Gender"
                value="O"
                defaultChecked={StudentDetails.Gender === "O"}
                onChange={(e) => FIllDetails(e)}
              />{" "}
              Other
            </div>
            {ErrorMessage.Gender && (
              <div className="error-message">{ErrorMessage.Gender}</div>
            )}
          </div>
          { GetGrade <= 10 && (<>
            <div className="dflex flexd-column" style={{ gap: "5px" }}>
              <label>
                Language <span>*</span>
              </label>
              <DropdownValues disabled={items.languageSubjectName.split(",")?.length != 2}
                options={items.languageSubjectName?.split(",").map((OL,Index)=>({display:OL,value:parseInt(items.languageSubjectId?.split(",")[Index])}))}
                onChange={(e) => SetOptionalSubjectsId(e.target.value)}
                selectoption={parseInt(OptionalSubjectId)}
                Displayname="Select Language"
              />
              {ErrorMessage.OptionalSubjectId && (
                <div className="error-message">
                  {ErrorMessage.OptionalSubjectId}
                </div>
              )}
            </div></>)}
          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              Medium of Instruction <span>*</span>
            </label>
            <DropdownValues disabled={true}
            options={[{display:items.medium,value:items.mediumId}]}
              onChange={(e) => SetMediumofInstructionId(e.target.value)}
              selectoption={MediumofInstructionId}
              Displayname="Select Medium of Instruction"
            />
            {ErrorMessage.MediumofInstructionId && (
              <div className="error-message">
                {ErrorMessage.MediumofInstructionId}
              </div>
            )}
          </div>
          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>Parent Contact Number</label>
            <input
              type="text"
              name="PContactNo"
              placeholder="Enter Parent Contact Number"
              value={StudentDetails.PContactNo}
               onChange={(
                e
              ) => FIllDetails(e)}
            />
            {ErrorMessage.PContactNo && (
              <div className="error-message">{ErrorMessage.PContactNo}</div>
            )}
          </div>
          { items?.societyName === 'NATCO' && (<>
          <div className="dflex flexd-column" style={{ gap: "5px" }}>
            <label>
              PST Status <span>*</span>
            </label>
            <DropdownValues 
               options={PstStatus}
              onChange={(e) => SetPSTStatusId(e.target.value)}
              selectoption={PSTStatusId}
              Displayname="Select PST Status"
            />
            {ErrorMessage.PSTStatusId && (
              <div className="error-message">
                {ErrorMessage.PSTStatusId}
              </div>
            )}
          </div></>)}
        </div>

        <div className="AddStudent-Buttons dflex mt-3">
          <button className="Buttons" onClick={SubmitForm}>
            {props.EditDetails ? "Update" : "Save"}
          </button>
          <button className="Buttons" onClick={() => props.Cancle(false)}>
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};
export default AddStudent;
